import ReactStrapTable from 'components/reactStrapTable';
import React, { useEffect, useState } from 'react'
import HoverImage from 'react-hover-image/build';
import { Button } from 'reactstrap';
import { cellRendererCheck, dateFormate } from 'utils/columns';
import Maping from "assets/icon/MapIcon.svg";
import MapHover from "assets/icon/MapIconHover.svg";
import UnMapped from "assets/icon/UnMapped.svg"
// import UnMappedHover from "assets/icon/UnMappedHover.svg"
import View from "assets/icon/icon-icon-options-view-patient.svg"
import ViewHover from "assets/icon/icon-icon-options-view-patient_hover.svg"
import useAxios from 'hooks/useAxios';
import { cloneDeep, filter } from 'lodash';
import Loader from 'components/Loader';
import { toast } from 'react-toastify';
import { ModuleAccess } from 'utils/moduleaccess';
import { orderBy } from 'lodash';



let initialValues = {}

const HiddenChargeCode = (props) => {
  const {
    unmapedChargeCount,
    manvalConfigedit,
    manvalConfig,
    manvalPharmacy,
    data,
    totalSize,
    unmapedNdcCount,
    filters,
    searchTerms,
    search,
    onExport,
    onclick,
    refetch,
    load,
    toggleSider,
    collapseSider,
    setNdcMapingFlag,
    ndcmapingflag,
    selectedRow,
    setselectedRow,
    resetFilterFlag,
    SetResetFilterFlag,
    orgId,
    unmappedchargesearch,
    setLoading,
    chargekey,
    totalhideRecords,
    setTotalHideRecords,
    loading,
    searchChargeCode,
    setSearchChargeCode,
    reset2
  } = props;
  const API = useAxios();

  //  const[tableData,setTableData]=useState(dummyData)
  const [hiddenChargeData, setHiddenChargeData] = useState([]);
  debugger;
  // const [totalhideRecords, setTotalHideRecords] = useState(0);
  const [initialValues, setInitialValues] = useState({
    ...unmappedchargesearch

  });
  const [columnFilters, setColumnFilters] = useState([]);
  const [disablehidebtn, setDisablehidebtn] = useState(false);

  useEffect(() => {
    fetchHiddenChargeCodes(initialValues)
  }, [chargekey, searchChargeCode]);
  useEffect(() => {
    setHiddenChargeData([]);
    setTotalHideRecords(0);
  }, [orgId, reset2,resetFilterFlag]);
  const fetchHiddenChargeCodes = async (initialValues) => {
    debugger;
    if (chargekey != 'hiddenchargeCodes') return null;
    if (window.selectedCoveredEntittyId == "" || window.selectedCoveredEntittyId == undefined) return null;
    setLoading(true);
    initialValues.AccumulatorID = unmappedchargesearch.AccumulatorID;
    try {
      setSearchChargeCode(false)
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/CrossWalk/HiddenChargeCodes`,
        initialValues,
        { hasDefaultURL: true }
      );
      if (data?.items?.length > 0) {
        setHiddenChargeData(data.items);
        setTotalHideRecords(data.totalRecords);
        setLoading(false);
      }
      else {
        setHiddenChargeData([]);
        setTotalHideRecords(0);
        setLoading(false);
      }
    } catch {
      setLoading(false);
    }
  };
  const onHandleSort = (filter, hasColFilter) => {
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };
  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    onPageChange(filter);
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      onPageChange(filter);
    }
  };
  const handleFilterCancel = () => {
    setColumnFilters([]);
    initialValues.filters = cloneDeep([]);
    initialValues.currentPage = cloneDeep(1);
    fetchHiddenChargeCodes(initialValues);
  };
  const onPageChange = (filter, haveColFilter) => {
    debugger;
    if (haveColFilter) {
      const filterObj = cloneDeep(initialValues);
      filterObj.filters = [...filterObj.filters, ...filter.filters];
      filterObj.currentPage = filter.currentPage;
      filterObj.pageSize = filter.pageSize;
      filterObj.order = filter.order;
      filterObj.orderBy = filter.orderBy;
      setInitialValues({
        currentPage: filter.currentPage,
        pageSize: filter.pageSize,
        ...filter
      })
      debugger
      fetchHiddenChargeCodes(filterObj);
    } else {
      debugger
      fetchHiddenChargeCodes(filter);
      setInitialValues({ ...initialValues, ...filter });
    }
    //updateStates(crosswalkQueue);
  };

  const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
      onSearchColumnFilters(colFilter);
      // setColFilters(colFilter);
    }
  };
  const onSearchColumnFilters = async (columnFilters) => {
    const filterObj = cloneDeep(unmappedchargesearch);
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
      setColumnFilters(columnFilters)
    }
    debugger
    filterObj.currentPage = 1;
    //unmappedchargesearch.currentPage = 1;
    initialValues.currentPage = cloneDeep(1);
    await fetchHiddenChargeCodes(filterObj);
  };
  const handleunhide = async (rowData, status) => {
    debugger;
    let accid = rowData?.accumulatorID;
    let chargeId = rowData?.chargeID
    setDisablehidebtn(true);
    setLoading(true);
    try {
      const { data } = await API.get(
        `SBTenant/${orgId.tenantID}/Crosswalk/HiddenAndUnHiddenchargeCode/${accid}/${chargeId}/${status}`,
        {
          hasDefaultURL: true,
        }
      );
      if (data.error == false) {
        fetchHiddenChargeCodes(initialValues)
        toast.success(data.message, {
          onClose: () => setDisablehidebtn(false),
        });
        setLoading(false);
      }
      else {
        setLoading(false);
      }
    } catch {
      setLoading(false);
    }
  };
  let mainCol = [
    {
      dataField: "edit",
      text: "Options",
      cellRenderer: (rowData) => cellRenderEdit(rowData),
      width: 93,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },


    {
      dataField: "ChargeCode1",
      text: "Charge Code",
      sort: true,
      width: 141,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.chargeCode),
    },
    {
      dataField: "chargeDescription",
      text: "Charge Description",
      sort: true,
      width: 241,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.chargeDescription),
    },
    // {
    //   dataField: "unmappedCharges",
    //   text: "Pending Utilization Count",
    //   sort: true,
    //   width: 100,
    //   show: true,
    //   inputType: "text",
    //   hideColFilter: false,
    //   cellRenderer: (row) => cellRendererCheck(row.unmappedCharges),
    // },
    {
      dataField: "createdDate",
      text: "Created Date",
      sort: true,
      width: 141,
      show: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (row) => dateFormate(row.createdDate),
    },
    {
      dataField: "modifiedByID",
      text: "Modified By",
      sort: false,
      width: 141,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.modifiedByID),
    },
    {
      dataField: "modifiedDate",
      text: "Modified Date",
      sort: true,
      width: 157,
      show: true,
      edit: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (row, col) => dateFormate(row.modifiedDate),
    },
    // {
    //   dataField: "hiddenReprocessFlag",
    //   text: "Responsive Flag",
    //     sort: true,
    //   width: 140,
    //   show: true,
    //   inputType: "text",
    //   hideColFilter: false,
    //   cellRenderer: (row) => cellRendererCheck(row.hiddenReprocessFlag),
    // },

  ];
  const renderMapping = (rowData) => {
    if (rowData.isEdit != true)
      return (
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          // onClick={() => togglemapingview(rowData)}
          title="Map"
        >
          <HoverImage key="Maping" src={Maping} hoverSrc={MapHover} alt="" />
        </Button>
      );
  };
  const hasPermission = (code) => {
    return ModuleAccess("CRW", code);
  };
  const renderUnMapped = (rowData) => {
    if (hasPermission("HI"))
      return (
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => handleunhide(rowData, 'unhide')}
          title="Unhide"
          disabled={disablehidebtn}
        >
          <HoverImage key="Maping" src={View} hoverSrc={ViewHover} alt="" />
        </Button>
      );
  };
  const cellRenderEdit = (rowData) => {
    return (
      <div className="d-flex align-items-center">


        {renderUnMapped(rowData)}

      </div>
    );
  };

  const handleExport = async () => {
    debugger;
    const filterObj = cloneDeep(unmappedchargesearch);
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters
        = [...filterObj.filters, ...columnFilters];
    }

    const { access_token } =
      JSON.parse(localStorage.getItem('pharmaforce')) || {};

    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
    additionalCriteria.OrgId = orgId.organizationID;
    // additionalCriteria.ContractId = 0;
    // additionalCriteria.POId = 0;
    // additionalCriteria.OpaId = 0;
    // additionalCriteria.CEId = 0;
    // additionalCriteria.ManufactureId = 0;

    var payload = {};
    payload.tenantID = orgId.tenantID
    payload.gridCode = "hiddencharges";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  };

  return (
    <div>
      {/* {loading && <Loader opacity = {0.01} />} */}
      <div
        className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={hiddenChargeData?.length > 0 ? "fixed-height" : "default"}
      >
        <ReactStrapTable
          id="hiddenchargecode"
          height={550}
          fixedColumn
          width={1200}
          hasPagination
          // reset={reset}
          data={hiddenChargeData}
          columns={mainCol}
          onExport={handleExport}
          filters={initialValues}
          totalRecords={totalhideRecords}
          pageSize={initialValues.pageSize}
          currentPage={initialValues.currentPage}
          handleSort={onHandleSort}
          onPageChange={onHandlePageChange}
          onPageSizeChange={onPageSizeChange}
          onFilterCancel={handleFilterCancel}
          onSearchColumnFilters={handleSearchColumnFilters}
          toggleSider={toggleSider}
          collapseSider={collapseSider}
          showtoggle={true}
        //   resetFilterFlag={resetFilterFlag}
        //   SetResetFilterFlag={SetResetFilterFlag}
        // hasExportPermission={hasExportPermission}
        />

      </div>
    </div>
  )
}

export default HiddenChargeCode